import React, { useEffect, useState } from "react";
import { Row, Col, Button } from "reactstrap";

import largeImg from "../assets/images/login-hero.svg";
import bannerImg from "../assets/images/voi-logo-type-for-login-screen-white.svg";
import { useEnvColor, useTitleFromComponent } from "../utils/hooks";
import LoadingFullScreen from "../components/LoadingFullScreen";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";

export default function Login() {
  const [appVersion, setAppVersion] = useState("");
  const envColor = useEnvColor();

  const {
    isLoading,
    loginWithRedirect,
  } = useAuth0();
  useTitleFromComponent("Login");

    useEffect(() => {
        if (appVersion === "") {
            const getVersion = async () => {
                try {
                    const verRes = await axios.get("/version.txt");
                    const ver = await verRes.data;
                    setAppVersion(ver);
                } catch (err) {}
            };

            getVersion();
        }
    }, [appVersion]);


    if (isLoading) return <LoadingFullScreen />;
    return (
        <div style={{ backgroundColor: "#0C1A4C", color: "white" }}>
        <Row className={"align-items-center vh-100 m-0 px-4"}>
        <Col xs={12} md={8}>
        <img
        src={largeImg}
        className={"w-100"}
        style={{ maxHeight: "90vh" }}
        alt={
            "Many IT assets being managed by a highly competent team using first rate analytical tools like Visual One Intelligence."
        }
        ></img>
        {/* <largeImg width="1rem" className="w-100" alt="Large." /> */}
        </Col>
        <Col xs={12} md={4} className={"text-center px-4"}>
        <img
        src={bannerImg}
        className={"w-100"}
        alt={"The logo for Visual One Intelligence"}
        ></img>
        <Button
        className={"w-100 my-2 btn-success"}
        onClick={loginWithRedirect}
        >
        Login
        </Button>
        <hr />
        <p style={{ fontSize: "14px", color: "#adb5bd" }} className="mt-4">
        Visual One Intelligence will be down for scheduled maintenance every
        Sunday between 12 PM and 4 PM CST.
        </p>
        <p style={{ fontSize: "0.7em", color: "#adb5bd" }} className="mt-4">
        {appVersion}-{envColor}
        </p>
        </Col>
        </Row>
        </div>
    );
}
